import {
  resolveBrandContextForHost,
  resolveRequestHostFromHeaders,
} from '@/lib/brand/approvedHosts';
import type { BrandContext } from '@/lib/brand/types';
import type { IncomingHttpHeaders, IncomingMessage } from 'http';
import type { NextApiRequest } from 'next';

type RequestLike = Pick<IncomingMessage, 'headers'> | NextApiRequest;

export const getBrandContext = (
  req?: RequestLike | null,
  env: Partial<Record<string, string | undefined>> = process.env
): BrandContext => {
  const headers = (req?.headers ?? {}) as IncomingHttpHeaders;
  return resolveBrandContextForHost(
    resolveRequestHostFromHeaders(headers),
    env
  );
};
